









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Models } from '@mtap-smartcity/api';
import { AppState } from '@/store/modules/app/types';
import {
  ScenariosAction,
  ScenariosActionType,
  ScenariosGetter,
  ScenariosGetterType,
  ScenariosState
} from '@/store/modules/scenarios/types';
import { CircuitsAction, CircuitsActionType, CircuitsState } from '@/store/modules/circuits/types';
import { GroupsGetter, GroupsGetterType } from '@/store/modules/groups/types';
import { naturalSort } from '@/utils/sort';
import { nameFilter } from '@/utils/name_filter';
import AssignAllCheckbox from '../AssignAllElements/AssignAllCheckbox/AssignAllCheckbox.vue';
import AssignAllModal from '../AssignAllElements/AssignAllModal/AssignAllModal.vue';
import ScenarioAssignmentConfirmModal from '../AssignAllElements/ScenarioAssignmentConfirmModal/ScenarioAssignmentConfirmModal.vue';

const groups = namespace('groups');
const scenarios = namespace('scenarios');
const circuits = namespace('circuits');
const app = namespace('app');

@Component({
  components: {
    AssignAllCheckbox,
    AssignAllModal,
    ScenarioAssignmentConfirmModal
  }
})
export default class AssignTableCircuits extends Vue {
  @Prop(String) readonly searchPhrase!: string

  @Prop(Boolean) readonly permissionWrite!: boolean

  @Prop(Boolean) readonly scenarioChangeConfirmation!: boolean

  @app.State
  userActionStatus!: AppState['userActionStatus'];

  @circuits.State
  circuits!: CircuitsState['circuits']

  @scenarios.State
  scenarios!: ScenariosState['scenarios']

  @scenarios.State
  scenarioElements!: ScenariosState['scenarioElements'];

  @scenarios.State
  selectedScenarioID!: ScenariosState['selectedScenarioID'];

  @scenarios.State
  selectedScenarioUuid!: ScenariosState['selectedScenarioUuid'];

  @scenarios.State
  selectedScenarioHasConnections!: ScenariosState['selectedScenarioHasConnections'];

  @groups.Getter(GroupsGetter.GetGroup)
  getGroup!: GroupsGetterType['GET_GROUP'];

  @scenarios.Getter(ScenariosGetter.GetScenario)
  getScenario!: ScenariosGetterType['GET_SCENARIO'];

  @scenarios.Getter(ScenariosGetter.GetScenarioById)
  getScenarioById!: ScenariosGetterType['GET_SCENARIO_BY_ID'];

  @circuits.Action(CircuitsAction.AddCircuitToScenario)
  addCircuitToScenario!: CircuitsActionType['ADD_CIRCUIT_TO_SCENARIO'];

  @scenarios.Action(ScenariosAction.SetSelectedScenarioHasConnections)
  SetSelectedScenarioHasConnections!: ScenariosActionType['SET_SELECTED_SCENARIO_HAS_CONNECTIONS'];

  featureReady: boolean = false;

  allChecked: boolean = false;

  allUnchecked: boolean = false;

  intervalID: any = null;

  dialog: boolean = false;

  modalAssignAll: boolean | null = null;

  confirmDialog: boolean = false;

  pendingCircuit: Models.Circuits.Model | null = null;

  pendingSwitchLoader: (() => void) | null = null;

  selectedScenarioName: string = '';

  get isDefaultScenario() {
    const defaultScenarioUuid = this.scenarios.find((s) => s.is_default)?.uuid;
    if (this.selectedScenarioUuid === defaultScenarioUuid) return true;
    return false;
  }

  get sortedCircuits() {
    let result = this.circuits.sort((a, b) => naturalSort(a.name, b.name));
    result = result.sort((a, b) => {
      if (this.belongsToSelectedScenario(a) && !this.belongsToSelectedScenario(b)) {
        return -1;
      }
      return 1;
    });
    return result.filter((c) => nameFilter(c.name, this.searchPhrase));
  }

  openModal(checkAllSelected: boolean) {
    this.modalAssignAll = checkAllSelected;
    this.dialog = true;
  }

  discardSubmit() {
    this.dialog = false;
  }

  async confirmSubmit(assignAll: boolean) {
    this.dialog = false;
    await this.addAllToScenario(assignAll);
    this.clearAllCheckbox();
  }

  groupName(circuit: Models.Circuits.Model) {
    const { group_id } = circuit;
    if (!group_id) {
      return '';
    }
    const { name } = this.getGroup(group_id) ?? { name: '' };
    return name;
  }

  scenarioName(circuit: Models.Circuits.Model) {
    const { scenario_id } = circuit;
    if (!scenario_id) {
      return '';
    }
    const { name } = this.getScenario(scenario_id) ?? { name: '' };
    return name;
  }

  belongsToSelectedScenario(circuit: Models.Circuits.Model) {
    if (circuit.scenario_id === this.selectedScenarioUuid) {
      if (!this.selectedScenarioHasConnections) this.SetSelectedScenarioHasConnections(true);
      return true;
    }
    return false;
  }

  checkAll() {
    clearInterval(this.intervalID);
    this.intervalID = setInterval(() => { this.allChecked = !this.allChecked; }, 700);
  }

  uncheckAll() {
    this.allChecked = false;
    clearInterval(this.intervalID);
    this.intervalID = setInterval(() => { this.allUnchecked = !this.allUnchecked; }, 700);
  }

  clearAllCheckbox() {
    clearInterval(this.intervalID);
    this.intervalID = null;
    this.allChecked = false;
    this.allUnchecked = false;
  }

  addAllToScenario(assignAll: boolean) {
    const circuitsToAssign = this.sortedCircuits.filter(
      (c: Models.Circuits.Model) => (
        assignAll ? !this.belongsToSelectedScenario(c) : this.belongsToSelectedScenario(c))
    );
    console.log(
      `With this action you would ${
        assignAll
          ? 'assign'
          : 'unassign'
      } following circuits:`, circuitsToAssign
    );
    this.clearAllCheckbox();
  }

  addToScenario(circuit: Models.Circuits.Model, switchLoader: () => void) {
    if (this.isDefaultScenario) return;

    if (this.scenarioChangeConfirmation) {
      // Show confirmation dialog and start spinner
      this.pendingCircuit = circuit;
      this.pendingSwitchLoader = switchLoader;
      const scenarioToBeAssigned = this.getScenario(this.selectedScenarioUuid ?? '');
      this.selectedScenarioName = scenarioToBeAssigned?.name ?? '';
      switchLoader(); // Start spinner when dialog opens
      this.confirmDialog = true;
    } else {
      // Proceed directly without confirmation
      this.performScenarioAssignment(circuit, switchLoader);
    }
  }

  discardScenarioAssignment() {
    this.confirmDialog = false;
    if (this.pendingSwitchLoader) {
      this.pendingSwitchLoader(); // Stop spinner when canceling
    }
    this.pendingCircuit = null;
    this.pendingSwitchLoader = null;
  }

  confirmScenarioAssignment() {
    this.confirmDialog = false;
    if (this.pendingCircuit && this.pendingSwitchLoader) {
      this.performScenarioAssignment(this.pendingCircuit, this.pendingSwitchLoader, false); // Spinner already started
    }
    this.pendingCircuit = null;
    this.pendingSwitchLoader = null;
  }

  performScenarioAssignment(circuit: Models.Circuits.Model, switchLoader: () => void, startSpinner: boolean = true) {
    if (startSpinner) {
      switchLoader();
    }

    const defaultScenarioUuid = this.scenarios.find((s) => s.is_default)?.uuid;
    const scenarioUuidToBeAssigned = this.belongsToSelectedScenario(circuit) ? defaultScenarioUuid : this.selectedScenarioUuid;
    const scenarioToBeAssigned = scenarioUuidToBeAssigned ? this.getScenario(scenarioUuidToBeAssigned) : null;

    const selectedScenarioName = this.scenarioName(circuit);
    const scenarioName = scenarioToBeAssigned?.is_default ? selectedScenarioName : scenarioToBeAssigned?.name;
    const modifiedCircuit = {
      ...circuit,
      scenario_id: scenarioUuidToBeAssigned,
    };
    const assigningToSelectedScenario = scenarioUuidToBeAssigned === this.selectedScenarioUuid;

    this.addCircuitToScenario({
      circuit: modifiedCircuit,
      scenarioName: scenarioName ?? null,
      assignToDefault: scenarioToBeAssigned?.is_default ?? true
    })
      .then(() => {
        this.SetSelectedScenarioHasConnections(assigningToSelectedScenario);
      })
      .finally(() => {
        switchLoader();
      });
  }
}
